import React, { Component } from 'react';
import { Container, Col, Row, Collapse } from 'react-bootstrap';
import { NavMenu } from './NavMenu';
import AppInfo from './AppInfo';
import Sidebar from './Sidebar';
import authService from './api-authorization/AuthorizeService'
import apiRequests from './api-helpers/ApiRequests'
import { Route, Routes, Navigate } from 'react-router-dom';
import LoginCallback from './LoginCallback';
import Home from './Home';
import Drivers from './Drivers';
import Semitrailers from './Semitrailers';
import Cars from './Cars';
import CompanyBar from './CompanyBar'
import Transports from './Transports';
import AuthorizeComponent from './api-authorization/AuthorizeComponent';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import ApiAuthorizationRoutes from './api-authorization/ApiAuthorizationRoutes';
import { ChangePasswordForm } from './ChangePasswordForm';




import { setUserData } from './redux/currentUserSlice'
import { useSelector, useDispatch } from 'react-redux'

class Layout extends Component {
	static displayName = Layout.name;

	constructor(props) {
		super(props);

		this.handleSidebarDisplayChange = this.handleSidebarDisplayChange.bind(this);

		this.state = {
			sidebarIsVisible: false,
			authorizeView: false,
			isPasswordChange: false,
			currentUser: new Object()
		};


		this.populateAuthenticationState = this.populateAuthenticationState.bind(this);

	}

	componentDidMount() {

		this.populateAuthenticationState();

	}

	handleSidebarDisplayChange() {

		this.setState({ sidebarIsVisible: !this.state.sidebarIsVisible });
	}

	async populateAuthenticationState() {

		const authenticated = await authService.isAuthenticated();
		let isPasswordChange = false;
		let currentUser = new Object();

		if (authenticated) {

			currentUser = await apiRequests.getDataByUrlWithParam('user/getcurrentuserdata', { x: 1 });
			isPasswordChange = currentUser.IsPasswordChanged;
			this.props.dispatch(setUserData(currentUser));
		}
		
		this.setState({ authorizeView: authenticated, isPasswordChange ,currentUser });
	}


	render() {

		const isSidebarVisible = this.state.sidebarIsVisible;
		const isPasswordChanged = this.state.isPasswordChange ? true : false;

		if (this.state.authorizeView == true && isPasswordChanged) {
			return (
				<div className={"app-content " + ( !this.state.sidebarIsVisible ? "small" : 'big' )}>
					<Sidebar onSidebarDisplayChange={this.handleSidebarDisplayChange} userName={this.state.currentUser.Email}  />
					{/*<div className="nav-container">
						<NavMenu onSidebarDisplayChange={this.handleSidebarDisplayChange} isSidebarVisible={isSidebarVisible} userName={this.state.currentUser.Email} />
					</div>*/}
					<CompanyBar companyName={this.state.currentUser.CompanyName || null} />
					<Col sm className="content-wrapper rounded-3">
						<Routes>
							<Route path='/' element={<AuthorizeComponent component={Home} path='/' layoutReady={true} isPasswordChanged={isPasswordChanged} />} />
							<Route path='/drivers' element={<AuthorizeComponent component={Drivers} layoutReady={true} isPasswordChanged={isPasswordChanged} />} />
							<Route path='/semitrailers' element={<AuthorizeComponent component={Semitrailers} layoutReady={true} isPasswordChanged={isPasswordChanged} />} />
							<Route path='/cars' element={<AuthorizeComponent component={Cars} layoutReady={true} isPasswordChanged={isPasswordChanged} />} />
							<Route path='/transports' element={<AuthorizeComponent component={Transports} layoutReady={true} isPasswordChanged={isPasswordChanged} />} />
							<Route path='/changepassword' element={<AuthorizeComponent component={ChangePasswordForm} layoutReady={true} path='/changepassword' isChangePasswordComponent />} />
							<Route path={ApplicationPaths.ApiAuthorizationPrefix + '/*'} element={<ApiAuthorizationRoutes />} />

							{/* 404 route � redirect to Home */}
							<Route path="*" element={<Navigate to="/" replace />} />
						</Routes>
						<AppInfo />
					</Col>
					
				</div>
			);
		}
		else {
			return (
				<div>
					<Routes>
						<Route exact path='/' element={<AuthorizeComponent component={Home} path='/' layoutReady={false} isPasswordChanged={isPasswordChanged} />} />
						<Route exact path='/drivers' element={<AuthorizeComponent component={Drivers} layoutReady={false} isPasswordChanged={isPasswordChanged} />} />
						<Route exact path='/semitrailers' element={<AuthorizeComponent component={Semitrailers} layoutReady={false} isPasswordChanged={isPasswordChanged} />} />
						<Route exact path='/cars' element={<AuthorizeComponent component={Cars} layoutReady={false} isPasswordChanged={isPasswordChanged} />} />
						<Route exact path='/transports' element={<AuthorizeComponent component={Transports} layoutReady={false} isPasswordChanged={isPasswordChanged} />} />
						<Route path='/changepassword' element={<AuthorizeComponent component={ChangePasswordForm} path='/changepassword' layoutReady={true} isChangePasswordComponent />} />
						{/*<Route path="/authentication/login-callback" element={<LoginCallback />} />*/}
						<Route path={ApplicationPaths.ApiAuthorizationPrefix + '/*'} element={<ApiAuthorizationRoutes />} />
					</Routes>
				</div>	
			);
		}	   
	}
}

function withMyHook(Component) {
	return function WrappedComponent(props) {

		const dispatch = useDispatch();

		return <Component {...props} dispatch={dispatch} />;
	}
}


export default withMyHook(Layout)
